import { Box, useTheme } from "@mui/material";
import NoteForm from "../../components/forms/noteForm/noteForm.component";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { resetFieldNoteState } from "../../store/features/fieldNote/fieldNoteSlice";
import { useIsMobile } from "../../hook/useIsMobile";

const AddNotePage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);

  useEffect(() => {
    dispatch(resetFieldNoteState());
  }, [dispatch]);

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column">
      <NoteForm theme={theme} accessToken={accessToken} isMobile={isMobile} />
    </Box>
  );
};

export default AddNotePage;
